import BusStopData from '../../schema/viewSchema/BusStopData';
import FoodEstablishment from '../../schema/innerSchema/FoodEstablishment';
import TxpStrings from '../../schema/configSchema/TxpStrings';

/**
 * Extracts the busStop data for dining cards
 */
export default function populateDiningBusStopData(
    restaurantInfo: FoodEstablishment,
    startTime: string,
    ariaStartTime: string,
    txpStrings: TxpStrings,
    icon: string
): BusStopData {
    let collapsedText: string;
    let ariaBusStopText: string;

    if (restaurantInfo.city) {
        collapsedText = txpStrings.formatters.format(
            txpStrings.strings.cityDateFormatText,
            restaurantInfo.city,
            startTime
        );
        ariaBusStopText = txpStrings.formatters.format(
            txpStrings.strings.cardWithCitySummaryAriaText,
            restaurantInfo.name,
            ariaStartTime,
            restaurantInfo.city
        );
    } else {
        collapsedText = startTime;
        ariaBusStopText = txpStrings.formatters.format(
            txpStrings.strings.cardSummaryAriaText,
            restaurantInfo.name,
            ariaStartTime
        );
    }

    return {
        icon: icon,
        busStopLabel: txpStrings.strings.reservationLabelText,
        busStopText: restaurantInfo.name,
        collapsedText: collapsedText,
        ariaBusStopText: ariaBusStopText,
    } as BusStopData;
}
